import { render, staticRenderFns } from "./ModalBulkItemImport.vue?vue&type=template&id=423e71c6&"
import script from "./ModalBulkItemImport.vue?vue&type=script&lang=js&"
export * from "./ModalBulkItemImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports